export const defaultLocaleId = 'en-US';
